import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import IcChevronRight from '../../assets/image/ic_chevron_right.svg';
import { useTranslation } from '../../hook/useTranslation';

function GotoHistory() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="w-full flex items-center justify-between py-4"
      onClick={() => navigate(Url.History)}
    >
      <div className="text-[14px] font-[700] text-[#1C1C1C]">{t('nav.growth_record')}</div>
      <div>
        <img src={IcChevronRight} alt="history" className="w-[24px] h-[24px]" />
      </div>
    </button>
  );
}

export default GotoHistory;
